module.exports = __webpack_public_path__ + "static/media/16.acd9cf34.jpg";